// import ComponentIcon from "../images/ComponentNewIcon.svg";
// import DownArrowIcon from "../images/DownArrowIcon.svg";
// import BackArrowIcon from "../images/blueBackarrow.svg";
// import CustomTooltip from "../components/Tooltip/Tooltip";
// import MLRStatusGreen from "../images/MLR StatusGreen.png";
// import MLRStatusGray from "../images/MLR StatusGray.png";
// import MLRStatusRed from "../images/MLR StatusRed.png";
// import LockIcon from "../images/Lock-Icon.svg";
import DashboardImage from "../../images/DashboardImage.svg";
import SaveChangesNewIcon from "../../images/save-changes-icon.svg";
import ComponentIcon from "../../images/code-editor-back-arrow.svg";

import "./PresentationStatus.scss";
import CustomTooltip from "../Tooltip/Tooltip";

const PresentationStatus = ({
  nameDrop,
  setShowAllSlides,
  setOpenPopup,
  slidesData,
  expandDetailDrop,
  expandName,
  editor,
  navigate,
  flowCreator,
  toggleSlidesPanelNEditor,
  setLoadSuccess,
  isPdfFlow = false,
}) => {
  return (
    <div className="dashboard-header d-flex align-items-center">
      <div className="d-flex align-items-center module-content-dashboard-header">
        <div className="module-content-dashboard-image">
          {flowCreator ? (
            <img
              src={ComponentIcon}
              alt=""
              onClick={() => {
                setShowAllSlides(false);

                // navigate("/", {
                //     replace: true,
                //     state: {
                //         type: localStorage.getItem("categoryType") === "2" ? 2 : 1,
                //     },
                // });
              }}
            />
          ) : (
            <img
              src={DashboardImage}
              alt=""
              onClick={() => {
                setTimeout(() => {
                  // editor.destroy();
                }, 0);

                navigate("/", {
                  replace: true,
                  state: {
                    type: localStorage.getItem("categoryType") === "2" ? 2 : 1,
                  },
                });
              }}
            />
          )}
        </div>
        <div className="module-content-dashboard-title">
          <h4 className="module-content-dashboard-title-label">
            Create {nameDrop?.type == 1 ? "Template" : "e-Detail"}
          </h4>
          <CustomTooltip
            title={nameDrop?.name}
            classes="dashboard-title-name-tooltip"
          >
            <h2 className="module-content-dashboard-title-name">
              {nameDrop?.name}
            </h2>
          </CustomTooltip>
        </div>
      </div>
      {flowCreator && !isPdfFlow && (
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ width: "100%", padding: "0 20px" }}
        >
          <div></div>
          <div>
            <button
              className={`btn btn-default import-html-package-default ${
                slidesData
                  ? "import-html-package-enable"
                  : "import-html-package-desable"
              }`}
              disabled={slidesData ? false : true}
              onClick={() => setOpenPopup(true)}
            >
              IMPORT HTML ZIP PACKAGE
            </button>
          </div>
        </div>
      )}
    </div>
    // <div className={` ${expandDetailDrop ? "activeExpand" : "inactiveExpand"}`}>
    //     <div className="dashboardIconLabel">
    //         {!flowCreator ? (<img
    //             src={ComponentIcon}
    //             width={24}
    //             height={24}
    //             alt=""
    //             onClick={() => {
    //                 //    appData.setToggleTemplate(1);
    //                 setTimeout(() => {
    //                     editor.destroy();
    //                 }, 0);

    //                 navigate("/", {
    //                     replace: true,
    //                     state: {
    //                         type: localStorage.getItem("categoryType") === "2" ? 2 : 1,
    //                     },
    //                 });
    //             }}
    //         />) : (<img
    //             className={`goBackArrow`}
    //             src={BackArrowIcon}
    //             width={15}
    //             height={15}
    //             alt=""
    //             onClick={toggleSlidesPanelNEditor}
    //         />)}

    //         <span className="expandDrop">
    //             <span>{nameDrop?.type == 1 ? "Template" : "e-Detail"} / </span>{" "}
    //             <span className="deckName">{nameDrop?.name}</span>
    //         </span>

    //         <img
    //             className={`${expandDetailDrop ? "collapseArrow" : "expandArrow"
    //                 }`}
    //             src={DownArrowIcon}
    //             width={15}
    //             height={15}
    //             alt=""
    //             onClick={expandName}
    //         />
    //     </div>

    //     <div
    //         className={`${expandDetailDrop ? "expandName" : "collapseName"}`}
    //     >
    //         <div className="templateNameLabel-class">
    //             <span className="presName">
    //                 {nameDrop?.type == 1 ? "Template" : "e-Detail"} name
    //             </span>
    //             {!nameDrop?.expired && (
    //                 <span style={{ width: "6%" }}>
    //                     <CustomTooltip
    //                         classes="mlrToolTip"
    //                         title={
    //                             nameDrop?.veevaMetadata?.length > 0
    //                                 ? nameDrop?.veevaMetadata[0]?.statusMLR
    //                                 : "Not Submitted"
    //                         }
    //                         arrow
    //                     >
    //                         <img
    //                             src={
    //                                 nameDrop?.veevaMetadata[0]?.statusMLR ===
    //                                     "Approved for Production"
    //                                     ? MLRStatusGreen
    //                                     : nameDrop?.veevaMetadata[0]?.statusMLR === "Rejected"
    //                                         ? MLRStatusRed
    //                                         : MLRStatusGray
    //                             }
    //                             alt="MLR Icon"
    //                             className="statusIcon"
    //                         />
    //                     </CustomTooltip>
    //                 </span>
    //             )}
    //             <span>
    //                 {nameDrop?.locked && nameDrop?.type === 1 && (
    //                     <img src={LockIcon} />
    //                 )}
    //             </span>
    //         </div>
    //         <div className="templateName-class" title={nameDrop?.name}>
    //             {nameDrop?.name}
    //         </div>
    //     </div>
    // </div>
  );
};
export default PresentationStatus;
